'use client';

import { clientFetch } from '@/lib/api/clientFetch';
import { useEffect, useState } from 'react';
import { ProductSpecsSkeleton } from '../ProductDetailSkeleton';
import ProductSpecsSection from './ProductSpecsSection';

const MIN_SKELETON_MS = 520;

export default function ProductSpecsSectionLoader({
  messages = {},
  productNumber,
}) {
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;
    let timeoutId;

    async function loadProduct() {
      setIsLoading(true);
      const startedAt = performance.now();

      try {
        const payload = await clientFetch(
          `/api/products/${encodeURIComponent(productNumber)}`,
        );

        if (isCancelled) {
          return;
        }

        setProduct(payload);
      } catch {
        if (isCancelled) {
          return;
        }

        setProduct(null);
      } finally {
        const elapsed = performance.now() - startedAt;
        const remaining = Math.max(0, MIN_SKELETON_MS - elapsed);

        timeoutId = window.setTimeout(() => {
          if (!isCancelled) {
            setIsLoading(false);
          }
        }, remaining);
      }
    }

    loadProduct();

    return () => {
      isCancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [productNumber]);

  if (isLoading) {
    return <ProductSpecsSkeleton />;
  }

  if (!product) {
    return null;
  }

  return <ProductSpecsSection messages={messages} product={product} />;
}
